import { AutoSizer as _AutoSizer, AutoSizerProps, Column as _Column, Table as _Table, List as _List, ListProps, ColumnProps, TableProps } from 'react-virtualized'
const TwinAutoSizer = _AutoSizer as unknown as React.FC<AutoSizerProps>;
const TwinColumn = _Column as unknown as React.FC<ColumnProps>;
const TwinTable = _Table as unknown as React.FC<TableProps>;
const TwinList = _List as unknown as React.FC<ListProps>;

export { TwinAutoSizer, TwinColumn, TwinTable, TwinList }